import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { PermissionAclService } from '../services/permission-acl.service';

@Injectable({
  providedIn: 'root'
})

export class ValidateRouteGuard {

  constructor(private router: Router, private permissionAcl: PermissionAclService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    let ids = state.url.match(/\d+/g);
    let id1 = parseInt(ids[0]);
    let id2 = parseInt(ids[1]);

    if (id1 && id2) {
      const parametro = route.data['parametro'];

      let obj = {
        idProjeto: id1,
        [parametro]: id2,
      }

      return new Promise((resolve, reject) => {
        this.permissionAcl.validateRoute(obj).subscribe({
          next: (res) => {
            if (res === false) {
              return this.router.navigate(['projetos', 'projeto', id1, 'cadastro']);
            }
            resolve(res);
          },
          error: (e) => reject(e)
        })
      });
    }
    else if (id1) {
      return this.router.navigate(['projetos', 'projeto', id1, 'cadastro']);
    }

    return true;
  }

}
